import { cn } from '../lib/utils';

/**
 * LinkVitals - 3 tiny colored bars showing speed/reliability/stability.
 *
 * Speed:      green <1s, yellow <3s, red >3s
 * Reliability: green=0 failures, yellow=1-2, red=3+
 * Stability:  green >30d since change, yellow >7d, red <7d
 */
export default function LinkVitals({
  consecutiveFailures = 0,
  lastStatusChange,
  lastResponseMs,
}) {
  // Calculate days since last status change
  const daysSinceChange = lastStatusChange
    ? Math.floor((Date.now() - new Date(lastStatusChange).getTime()) / (1000 * 60 * 60 * 24))
    : null;

  // Speed bar
  const speedColor = lastResponseMs == null
    ? 'bg-muted-foreground/20'
    : lastResponseMs < 1000
      ? 'bg-success'
      : lastResponseMs < 3000
        ? 'bg-warning'
        : 'bg-destructive';

  // Reliability bar
  const reliabilityColor = consecutiveFailures === 0
    ? 'bg-success'
    : consecutiveFailures <= 2
      ? 'bg-warning'
      : 'bg-destructive';

  // Stability bar
  const stabilityColor = daysSinceChange == null
    ? 'bg-muted-foreground/20'
    : daysSinceChange > 30
      ? 'bg-success'
      : daysSinceChange > 7
        ? 'bg-warning'
        : 'bg-destructive';

  // Tooltip text
  const tooltipParts = [
    `Speed: ${lastResponseMs != null ? `${lastResponseMs}ms` : 'N/A'}`,
    `Failures: ${consecutiveFailures}`,
    `Stable: ${daysSinceChange != null ? `${daysSinceChange}d` : 'N/A'}`,
  ];

  return (
    <div
      className="flex flex-col gap-[2px] w-10 cursor-default"
      title={tooltipParts.join(' | ')}
    >
      <div className={cn('h-[3px] rounded-full', speedColor)} />
      <div className={cn('h-[3px] rounded-full', reliabilityColor)} />
      <div className={cn('h-[3px] rounded-full', stabilityColor)} />
    </div>
  );
}
